var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQonto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920 560",
    style: {
      enableBackground: "new 0 0 1920 560"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n  .st0{fill:#111111;}\n ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M984.6,533.1h73V327c0-50.5,34.8-88.7,81.2-88.7c46.4,0,84.6,38.2,84.6,88.7v206h78.5V321.6 c0-89.4-72.3-156.9-151.5-156.9c-30,0-65.7,9.4-92.8,46.8v-38.6h-73V533.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1724.8,164.6c-105.8,0-186.9,83.9-186.9,189.7c0,108.5,81.2,186.9,186.9,186.9 c108.5,0,189.7-78.5,189.7-186.9C1914.5,248.6,1833.3,164.6,1724.8,164.6z M1724.8,465.5c-59.4,0-108.5-49.1-108.5-111.2 c0-65.5,49.1-113.9,108.5-113.9c62.8,0,111.2,48.4,111.2,113.9C1836,416.4,1787.6,465.5,1724.8,465.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1524.2,533.1v-75.7c-54.6,27.3-105.8,5.5-105.8-54.6V245.8h97.6v-73h-97.6V80h-75.7v309.8 C1342.8,516.7,1429.4,560.4,1524.2,533.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M754,164.6c-105.8,0-186.9,83.9-186.9,189.7c0,108.5,81.2,186.9,186.9,186.9c108.5,0,189.7-78.5,189.7-186.9 C943.6,248.6,862.4,164.6,754,164.6z M754,465.5c-60,0-108.5-49.1-108.5-111.2c0-65.5,48.4-113.9,108.5-113.9 c62.1,0,111.2,48.4,111.2,113.9C865.2,416.4,816,465.5,754,465.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M268.2,7C119.4,7,5.5,121,5.5,275.9c0,148.7,113.9,265.4,262.7,265.4c152.1,0,266.1-116.7,266.1-265.4 C534.3,121,420.3,7,268.2,7z M268.2,462.8c-103,0-178.8-78.5-178.8-186.9c0-111.2,75.7-193.1,178.8-193.1 c105.8,0,182.2,81.9,182.2,193.1C450.3,384.3,373.9,462.8,268.2,462.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M521.8,553C373.2,536.8,278,460.7,231,320.4l74.4-24.9c37.3,111.3,106.7,166.6,225,179.5L521.8,553z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQonto);
export default __webpack_public_path__ + "static/media/qonto.3f48734e38d0c79138e37be4147418da.svg";
export { ForwardRef as ReactComponent };